<!-- START BLOG -->
<section class="section bg-light pt-5" id="awards">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-title text-center">AWARDS</h1>
        <div class="section-title-border mt-3"></div>
        <!-- <p class="section-subtitle text-muted text-center font-secondary pt-4">Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean class at a euismod mus ipsum vel ex finibus semper luctus quam.</p>-->
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-lg-4">
        <div class="blog-box mt-4 hover-effect">
          <img src="assets/images/BRPAward.png" class="img-fluid2" alt="">
          <div>
            <!--<h5 class="mt-4 text-muted">UI & UX Design</h5>-->
            <h4 class="mt-3" >Best Research Papers of 2022</h4>
            <p class="text-muted">'Creation of a Self-Sustaining Token Economy’ by Dr. Oleksandr Letychevskyi is one of
              the Best Research Papers of 2022 in the 'Crypto-economics or Blockchain Economics' category.
              <br>
              <br>
              <a href="https://britishblockchainassociation.org/jbba-announces-best-research-papers-of-2022/" target="_blank">The list
                of the Best Research Papers of 2022</a> (papers published during the period 20 November 2021 – 10
              December 2022) was announced by The Journal of the British Blockchain Association.
            </p>
            <!--<div class="mt-3">
              <a href="" class="read-btn">Read More <i class="mdi mdi-arrow-right"></i></a>
            </div>-->
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="blog-box mt-4 hover-effect">
          <img src="assets/images/BRAAward.jpg" class="img-fluid2" alt="">
          <div>
           <!-- <a class="blog-title"></a>-->
            <h4 class="mt-3" >The best research abstract and presentation</h4>
            <p class="text-muted">Bronze award for the best research abstract and presentation as a result of
              participation in the 4th Blockchain International conference conducted by the British Blockchain
              Association in March 2022.
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="blog-box mt-4 hover-effect">
          <img src="assets/images/BBRAward.jpg" class="img-fluid2" alt="">
          <div>
            <h4 class="mt-3">Best blockchain research abstract</h4>
            <p class="text-muted">2nd Price for the best research abstract as a result of participation in the
              Scientific International Blockchain conference in Edinburg in 2021.
            </p>
          </div>
        </div>
      </div>

    </div>

  </div>
</section>
<!-- END BLOG -->